module.exports = new __parcel__URL__("gcdreduce.e003012d.png").toString();